import { createHttpInstance } from '~/common/utils/http';

const httpInstance = createHttpInstance('gateway');

export default httpInstance;
